import React, { useEffect } from 'react';
import { Box, Chip, Divider, Stack, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
   accountStore,
   resetDefaultBillingStatus,
   resetDeleteBillingStatus,
} from 'features/account/stores/account.slice';

import { LoadStatus } from 'config/utils';
import {
   checkoutPaymentStore,
   setDefaultPaymentDialogOpen,
   setDeletePaymentDialogOpen,
   setPaymentToDefault,
   setPaymentToDelete,
} from 'features/checkout/stores/checkout-payment.slice';
import DeletePaymentDialog from 'features/checkout/components/paymentDetails/DeletePayementDialog';
import DefaultPaymentDialog from 'features/checkout/components/paymentDetails/DefaultPaymentDialog';
import BrandCreditCardIcon from 'components/BrandCreditCardIcon';
import MorePaymentOption from 'features/checkout/components/paymentDetails/MorePaymentOption';

const PaymentBook = () => {
   const { billingProfiles, deleteBillingStatus, defaultBillingStatus } = useAppSelector(accountStore);
   const { deletePaymentDialogOpen, defaultPaymentDialogOpen } = useAppSelector(checkoutPaymentStore);
   const dispatch = useAppDispatch();

   const onDeletePaymentStatus = () => {
      if (deleteBillingStatus === LoadStatus.complete) {
         dispatch(resetDeleteBillingStatus());
         dispatch(setPaymentToDelete(null));
         dispatch(setDeletePaymentDialogOpen(false));
      }
   };

   const onDefaultPaymentStatus = () => {
      if (defaultBillingStatus === LoadStatus.complete) {
         dispatch(resetDefaultBillingStatus());
         dispatch(setPaymentToDefault(null));
         dispatch(setDefaultPaymentDialogOpen(false));
      }
   };

   useEffect(() => {
      onDeletePaymentStatus();
   }, [deleteBillingStatus]);

   useEffect(() => {
      onDefaultPaymentStatus();
   }, [defaultBillingStatus]);

   return (
      <>
         <Box mt={2} mb={3} width={'100%'}>
            <div className="addresses-list">
               <Stack direction="column">
                  {billingProfiles.map((payment, index) => (
                     <Box key={`payment-method-${index}`}>
                        <Box display="flex" alignItems="center">
                           <Stack direction="row" display="block">
                              <Typography variant="body1" fontWeight="bold">
                                 {payment?.firstName} {payment?.lastName}
                              </Typography>
                              <Typography variant="body1">{payment?.address}</Typography>
                              {payment?.address && (
                                 <Typography variant="body1">
                                    {payment?.city}, {payment?.region} {payment?.postal}
                                 </Typography>
                              )}
                              <Box display="flex" alignItems="center" mb={3} mt={3} component="span">
                                 <BrandCreditCardIcon brand={payment.cardBrand} />
                                 <Typography variant="body1" ml={0.5}>
                                    Card ending in {payment?.accountNum}
                                 </Typography>
                              </Box>
                           </Stack>
                           <Box ml="auto">
                              <Stack direction="column">
                                 {payment.default ? <Chip label={'Default'} sx={{ marginBottom: '5px' }} /> : null}
                                 <Box ml="auto">
                                    <MorePaymentOption payment={payment} />
                                 </Box>
                              </Stack>
                           </Box>
                        </Box>
                        {index < billingProfiles.length - 1 && (
                           <Divider orientation="horizontal" flexItem sx={{ borderWidth: 1, margin: '0.5rem 20px' }} />
                        )}
                     </Box>
                  ))}
               </Stack>
            </div>
         </Box>
         {deletePaymentDialogOpen && <DeletePaymentDialog />}
         {defaultPaymentDialogOpen && <DefaultPaymentDialog />}
      </>
   );
};

export default PaymentBook;
